let entitydbCd = {
    "pinned": [
      "CompanyName"
    ],
    "width": {
      "CompanyName": 240
    },
    "immutable": {
      "CompanyName": false
    },
    "mapping": {
      "CompanyName": {
        "header": "Company Name",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CompanyName"
      },
      "EntityType": {
        "header": "Entity Type",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "EntityType",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Corporation",
          "General Partnership",
          "Limited Liability Company",
          "Limited Liability Partnership",
          "Partnership",
          "Limited Partnership"
        ]
      },
      "Purpose": {
        "header": "Entity Purpose",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Purpose",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "AIV",
          "AIV Yukon",
          "Blocker",
          "Carry Vehicle",
          "Co-Investment",
          "Comingled Fund",
          "Feeder Fund",
          "General Partner",
          "Management Company",
          "Parallel Fund",
          "Partner Vehicle",
          "Separate Account",
          "Side Car",
          "Sleeve Fund",
          "SPV"
        ]
      },
      "FundFamily": {
        "header": "Fund Family",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FundFamily",
        "element": "dropdown",
        "cellEditor": "agTextCellEditor",
        "dropdown": [
          "Fund I",
          "Fund II",
          "Fund III",
          "Fund IV",
          "Fund V",
          "Fund VI",
          "Fund VII"
        ]
      },
      "Country": {
        "header": "Country",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Country",
        "cellEditor": "agTextCellEditor"
      },
      "State": {
        "header": "State",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "State",
        "cellEditor": "agTextCellEditor"
      },
      "Status": {
        "header": "Company Status",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Status",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Active",
          "Dissolved",
          "In Liquidation",
          "Liquidated",
          "Struck Off"
        ]
      },
      "DissolveDate": {
        "header": "Dissolved Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "DissolveDate",
        "cellEditor": "agTextCellEditor"
      },
      "RegDate": {
        "header": "Entity Registration Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "RegDate",
        "cellEditor": "agTextCellEditor"
      },
      "RegNum": {
        "header": "Entity Registration Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "RegNum",
        "cellEditor": "agTextCellEditor"
      },
      "EIN": {
        "header": "Employee Identification Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "EIN",
        "cellEditor": "agTextCellEditor"
      },
      "GP": {
        "header": "General Partner",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "GP",
        "cellEditor": "agTextCellEditor"
      },
      "SAClient": {
        "header": "Separate Account Client",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "SAClient",
        "cellEditor": "agTextCellEditor"
      },
      "DealRef": {
        "header": "Deal Reference",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "DealRef",
        "cellEditor": "agTextCellEditor"
      },
      "FYEnd": {
        "header": "Fiscal Year End",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FYEnd",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "March 31",
          "June 30",
          "September 30",
          "December 31"
        ]
      },
      "RegAgent": {
        "header": "Registered Agent",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "RegAgent",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "National Registered Agents, Inc.",
          "Maples Corporate Services Limited"
        ]
      },
      "USCounsel": {
        "header": "US Counsel",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "USCounsel",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Pillsbury",
          "Ropes & Gray"
        ]
      },
      "ForeignCounsel": {
        "header": "Foreign Counsel",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ForeignCounsel",
        "element": "dropdown",
        "cellEditor": "agTextCellEditor",
        "dropdown": [
          "Maples Corporate Services Limited",
          "King & Wood",
          "Clifford Chance",
          "Torys",
          "Simmons & Simmons",
          "Not Applicable"
        ]
      },
      "PlaceAgent": {
        "header": "Placement Agent",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PlaceAgent",
        "cellEditor": "agTextCellEditor"
      },
      "Custodian": {
        "header": "Custodian",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Custodian",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "First Republic Bank",
          "Not Applicable"
        ]
      },
      "FundAuditor": {
        "header": "Fund Auditor",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FundAuditor",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Ernst & Young",
          "Burr Pilger Mayer",
          "RSM Malta",
          "PriceWaterhouseCoopers",
          "Deloitte",
          "VRC",
          "Not Applicable"
        ]
      },
      "TaxProvider": {
        "header": "Tax Provider",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "TaxProvider",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Anderson",
          "Deloitte",
          "WTAS",
          "PriceWaterhouseCoopers",
          "Asia Alternatives",
          "Asia Alternatives - Final",
          "Not Applicable"
        ]
      },
      "PrimeBroker": {
        "header": "Prime Broker",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PrimeBroker",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "First Republic Bank",
          "Mirae Asset",
          "Not Applicable"
        ]
      },
      "LoC": {
        "header": "Line of Credit",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "LoC",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "LocAmount": {
        "header": "Line of Credit Amount",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "LocAmount",
        "cellEditor": "agTextCellEditor"
      },
      "CAStatus": {
        "header": "California Registration Status",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CAStatus",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Active",
          "Canceled",
          "Not Applicable"
        ]
      },
      "CALPNum": {
        "header": "CA LP/LLC Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CALPNum",
        "cellEditor": "agTextCellEditor"
      },
      "CARegDate": {
        "header": "California Registration Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CARegDate",
        "cellEditor": "agTextCellEditor"
      },
      "CACanDate": {
        "header": "California Registration Cancellation Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CACanDate",
        "cellEditor": "agTextCellEditor"
      },
      "ADVFiler": {
        "header": "ADV Filer",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ADVFiler",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "PFFiler": {
        "header": "Form PF Filer",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PFFiler",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "MainAddress": {
        "header": "Main Office Address",
        "rules": null,
        "dataType": "text",
        "element": "dropdown",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "MainAddress",
        "cellEditor": "agTextCellEditor",
        "dropdown": [
          "One Embarcadero Center, 16th Floor, San Francisco CA 94111, United States",
          "1720 Orchard Lane, Walnut Creek CA, 94595, United States"
        ]
      },    
      "RegAddress": {
        "header": "Registered Office Address",
        "rules": null,
        "dataType": "text",
        "element": "dropdown",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "RegAddress",
        "cellEditor": "agTextCellEditor",
        "dropdown": [
          "c/o National Registered Agents, Inc., 160 Greentree Drive, Suite 101, Dover DE 19904, United States",
          "c/o Maples Corporate Services Limited, PO Box 309, Ugland House, Grand Cayman, KY1-1104, Cayman Islands"
        ]
      } 
    }
  }
  export  { entitydbCd }
  